mutation generateSettlements($year: Int, $month: Int) {
  generateSettlements(year: $year, month: $month) {
    year
    month
  }
}
